import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import { GrLocation } from "react-icons/gr";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  ERROR_EXISTS,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import Moment from "moment";
import Loader from "../../../../components/Loader/Loader";

const Locations = (props) => {
  // For ItemsRack
  const { Listofdata, callback } = props;

  const [SubmitEvent, setSubmitEvent] = useState(0);
  const paramObject = useParams();
  const buttonRef = React.useRef(null);
  const [inventoryValues, setInventoryValues] = useState();
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const Loaction = localStorage.getItem("Location");
  const [aisleRows, setAisleRows] = useState([]);
  const [binRows, setBinRows] = useState([]);
  const [rackRows, setRackRows] = useState([]);
  const [shelfRows, setShelfRows] = useState([]);
  const [item, setItem] = useState([Listofdata || []]);
  const [isItem, setIsItem] = useState(false);
  const [ailseSelecte, setAilseSelecte] = useState([]);
  const [binSelecte, setBinSelecte] = useState([]);
  const [rackSelecte, setRackSelecte] = useState([]);
  const [shelfSelecte, setShelfSelecte] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectMultipleItemRackFlag, setSelectMultipleItemRackFlag] = useState({
    aisleFlag: false,
    rackFlag: false,
    shelfFlag: false,
    binFlag: false,
  });

  const [type, setType] = useState([]);
  // const [loading, setLoading] = useState(false);

  console.log(isItem, "isItem");

  const [variationLength, setVariationLength] = useState();
  const [locationData, setLocationData] = useState([]);
  const [taxGroup, setTaxGroup] = useState([]);
  const [locationItem, setLocationItem] = useState([]);
  const [variationItem, setVariationItem] = useState([]);
  const [totalLocation, setTotalLocation] = useState([]);
  const [overRidePricesValues, setOverRidePricesValues] = useState([]);
  const [overDefaultTaxValues, setOverDefaultTaxValues] = useState([]);

  const [inputCostPriceValues, setInputCostPriceValues] = useState([]);
  const [inputUnitPriceValues, setInputUnitPriceValues] = useState([]);
  const [inputReorderLevelValues, setInputReorderLevelValues] = useState([]);
  const [formValues, setFormValues] = useState({
    ID: 0,
    DoNotSellAtThisLocation: 0,
    HideFromGrid: 0,
    Location: "",
  });
  const [inputReplenishLevelValues, setInputReplenishLevelValues] = useState(
    []
  );

  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  function handleButtonClick() {
    buttonRef.current.click();
  }
  const handleSubmitForm = () => {
    setSubmitEvent(1);
    handleItemsRackSubmit();
    // navigate("/items")
  };
  // handle Aisle
  const handleAisle = (index, event) => {
    const values = event?.map((option) => option.value);
    ailseSelecte[index] = values;
    let customEvent = {
      target: {
        name: "aisle",
        values: ailseSelecte[index].toString(),
      },
    };
    handleChange(index, customEvent);
  };

  // handle Bin
  const handleBin = (index, event) => {
    const values = event?.map((option) => option.value);
    binSelecte[index] = values;
    let customEvent = {
      target: {
        name: "bin",
        values: binSelecte[index].toString(),
      },
    };
    handleChange(index, customEvent);
  };

  // handle Shelf
  const handleShelf = (index, event) => {
    const values = event?.map((option) => option.value);
    shelfSelecte[index] = values;
    let customEvent = {
      target: {
        name: "shelf",
        values: shelfSelecte[index].toString(),
      },
    };
    handleChange(index, customEvent);
  };

  // handle Rack
  const handleRack = (index, event) => {
    const values = event?.map((option) => option.value);
    rackSelecte[index] = values;
    let customEvent = {
      target: {
        name: "rack",
        values: rackSelecte[index].toString(),
      },
    };
    // const customEvent = { name: "Aisle", values: SelectedVariation[index].toString() }; // Creating a custom event object
    handleChange(index, customEvent); // Passing the custom event object
    // console.log("rackSelecte==>", customEvent);
  };

  //handlechange of alls
  const handleChange = (index, event) => {
    let name, values;
    name = event.target.name;
    values = event.target.values;
    const rowsInput = [...item];
    rowsInput[index][name] = values;

    if (
      index === 0 &&
      name === "aisle" &&
      !selectMultipleItemRackFlag.aisleFlag
    ) {
      for (let i = 0; i < rowsInput.length; i++) {
        rowsInput[i][name] = values;
      }
      setSelectMultipleItemRackFlag({
        ...selectMultipleItemRackFlag,
        aisleFlag: true,
      });
    } else if (
      index === 0 &&
      name === "rack" &&
      !selectMultipleItemRackFlag.rackFlag
    ) {
      for (let i = 0; i < rowsInput.length; i++) {
        rowsInput[i][name] = values;
      }
      setSelectMultipleItemRackFlag({
        ...selectMultipleItemRackFlag,
        rackFlag: true,
      });
    } else if (
      index === 0 &&
      name === "shelf" &&
      !selectMultipleItemRackFlag.shelfFlag
    ) {
      for (let i = 0; i < rowsInput.length; i++) {
        rowsInput[i][name] = values;
      }
      setSelectMultipleItemRackFlag({
        ...selectMultipleItemRackFlag,
        shelfFlag: true,
      });
    } else if (
      index === 0 &&
      name === "bin" &&
      !selectMultipleItemRackFlag.binFlag
    ) {
      for (let i = 0; i < rowsInput.length; i++) {
        rowsInput[i][name] = values;
      }
      setSelectMultipleItemRackFlag({
        ...selectMultipleItemRackFlag,
        binFlag: true,
      });
    } else {
      rowsInput[index][name] = values;
    }
    setItem(rowsInput);
  };

  const handledropdwon = () => {
    axios
      .get(
        `${config.itemsBaseUrl}/items/itemgetlocationrackget?locationId=${Loaction}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log(res.data.ResponseData.AisleData);
        // .BinData.RackData.ShelfData

        setAisleRows(res.data.ResponseData.AisleData);
        setBinRows(res.data.ResponseData.BinData);
        setRackRows(res.data.ResponseData.RackData);
        setShelfRows(res.data.ResponseData.ShelfData);
        //setTaxGroup(res.data.ResponseData);
      })
      .catch((err) => {
        // console.log("error: " + err);
      });
  };

  let Aislelist = [];
  const Aislelists = aisleRows?.map((u, i) => {
    Aislelist[i] = { label: u.Name, value: u.ID };
  });

  let Binlist = [];
  const Binlists = binRows?.map((u, i) => {
    Binlist[i] = { label: u.Name, value: u.ID };
  });

  let Shelflist = [];
  const Shelflists = shelfRows?.map((u, i) => {
    Shelflist[i] = { label: u.Name, value: u.ID };
  });

  let Racklist = [];
  const Racklists = rackRows?.map((u, i) => {
    Racklist[i] = { label: u.Name, value: u.ID };
  });

  const handleItemsRackSubmit = () => {
    //for Data Json
    // console.log("step 2");

    let Jsondata = item?.filter(function (item) {
      return item.VariationName != "";
    });
    const Jsonobject = {};
    Jsonobject.rackxml = Jsondata;
    let jsonstring = "";
    jsonstring = JSON.stringify(Jsonobject);

    console.log("Jsondata 224", Jsondata);
    setLoading(true);
    axios
      .post(
        `${config.itemsBaseUrl}/items/Rackmanagement`,
        {
          rackitemxml: jsonstring,
          loginuserid: loginUserId,
          itemid: paramObject.id,
          ID: formValues?.ID ? formValues.ID : 0,
          LocationID: Loaction,
          DoNotSellAtThisLocation: formValues?.DoNotSellAtThisLocation,
          HideFromGrid: formValues?.HideFromGrid,
          LocationAtStore: formValues?.Location,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          if (SubmitEvent == 1) {
            setSubmitEvent(0);
          } else {
            props.nextStep();
            window.scrollTo(0, 0);
          }

          getLocationApi();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  const getLocationApi = () => {
    axios
      .get(
        `${config.itemsBaseUrl}/items/itemsrackselectbyid?ItemId=${paramObject.id}&locationId=${Loaction}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("???>>>>", res.data.ResponseData);
        const responseData = res.data.ResponseData.data1;
        setItem(responseData);
        setIsItem(!responseData[0]?.variationid ? true : false);
        setFormValues(res.data.ResponseData.data2[0]);
      })
      .catch((err) => {
        console.log("error: " + err);
      });
    handledropdwon();
  };

  useEffect(() => {
    if (paramObject.id > 0) {
      getLocationApi();
    }
  }, [props]);
  // For ItemsRack
  // console.log("itemss::>>>", item);

  let navigate = useNavigate();
  // const paramObject = useParams();
  const Id = localStorage.getItem("ID");

  // Tax Group DropDown
  let taxGroupOptions = [];
  const TaxGroupDropDown = taxGroup?.map((u, i) => {
    taxGroupOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const handleCheckBoxChange = (index, value, fieldName) => {
    // console.log(index, value);

    // For DoNotSell
    if (fieldName === "DoNotSell") {
      const updatedData = [...locationData];
      updatedData[index] = {
        ...updatedData[index],
        DoNotSell: value === true ? 1 : 0,
      };
      // console.log("updatedData: ", updatedData);
      setLocationItem(updatedData);
    }
    // For HideGrid
    else if (fieldName === "HideGrid") {
      const updatedData = [...locationData];
      updatedData[index] = {
        ...updatedData[index],
        HideGrid: value === true ? 1 : 0,
      };
      setLocationItem(updatedData);
      // console.log("updatedData: ", updatedData);
    }
  };

  // Handle function for Location values
  const handleChangeForValues = (index, event, fieldName) => {
    let name, values;

    if (fieldName === "TaxGroup") {
      name = fieldName;
      values = event.value;
    } else if (event.target.type === "checkbox") {
      name = event.target.name;
      values = event.target.checked === true ? 1 : 0;
    } else {
      name = event.target.name;
      values = event.target.value;
    }

    // console.log(index, name, values);
    let cardInput = [...locationItem];
    if (cardInput[index]) {
      cardInput[index][name] = values;
      setLocationItem(cardInput);
    }
  };

  // Function to handle all CostPrice values of input fields
  const handleInputCostPriceChange = (
    event,
    inputIndex,
    variationID,
    locationID,
    VaritionUpdateInsertID
  ) => {
    const newValue = {
      CostPrice: event.target.value,
      LocationId: locationID,
      ItemVariationId: variationID,
      LocationItemVariationID: VaritionUpdateInsertID,
    };
    setInputCostPriceValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[inputIndex] = newValue;
      return newValues;
    });
  };

  const handleInputUnitPriceChange = (
    event,
    inputIndex,
    variationID,
    locationID,
    VaritionUpdateInsertID
  ) => {
    const newValue = {
      UnitPrice: event.target.value,
      LocationId: locationID,
      ItemVariationId: variationID,
      LocationItemVariationID: VaritionUpdateInsertID,
    };
    setInputUnitPriceValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[inputIndex] = newValue;
      return newValues;
    });
  };

  const handleInputReorderLevelChange = (
    event,
    inputIndex,
    variationID,
    locationID,
    VaritionUpdateInsertID
  ) => {
    const newValue = {
      ReorderLevel: event.target.value,
      LocationId: locationID,
      ItemVariationId: variationID,
      LocationItemVariationID: VaritionUpdateInsertID,
    };
    setInputReorderLevelValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[inputIndex] = newValue;
      return newValues;
    });
  };

  // Function to handle all ReplenishLevel values of input fields
  const handleInputReplenishLevelChange = (
    event,
    inputIndex,
    variationID,
    locationID,
    VaritionUpdateInsertID
  ) => {
    const newValue = {
      ReplenishLevel: event.target.value,
      LocationId: locationID,
      ItemVariationId: variationID,
      LocationItemVariationID: VaritionUpdateInsertID,
    };
    setInputReplenishLevelValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[inputIndex] = newValue;
      return newValues;
    });
  };

  // Handle Change for OverridePrices CheckBox
  const handleOverridePricesChange = (index, event) => {
    const newCheckboxes = [...overRidePricesValues];
    newCheckboxes[index] = !newCheckboxes[index];
    setOverRidePricesValues(newCheckboxes);
  };

  // Handle Change for OverrideDefaultTax CheckBox
  const handleOverrideDefaultTaxChange = (index, event) => {
    const newCheckboxes = [...overDefaultTaxValues];
    newCheckboxes[index] = !newCheckboxes[index];
    setOverDefaultTaxValues(newCheckboxes);
  };

  // Action Button Function
  const ActionButtons = (props) => {
    const handleBack = () => {
      props.previousStep();
      window.scrollTo(0, 0);
    };

    return (
      <div className="text-center">
        {props.currentStep > 1 && (
          <button onClick={handleBack} className="btn btn-primary me-3">
            Back
          </button>
        )}

        <button onClick={handleSubmit} className="btn btn-primary me-3">
          Submit
        </button>
      </div>
    );
  };

  // Onload binding Tax Group DropDown, Total number of Location Card and Varition field based upon the data in the database table according to itemID
  useEffect(() => {
    //  Binding TaxGroup DropDown
    axios
      .get(`${config.generalBaseUrl}/generals/taxesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTaxGroup(res.data.ResponseData);
        // console.log(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("error: " + err);
      });

    // Binding Location Fields
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        // console.log("locationvariation::>>", res.data.ResponseData);
        setType(res.data.ResponseData);
        setTotalLocation(res.data.ResponseData);
        let locationlength = res.data.ResponseData.length;
        // setLocationLength(res.data.ResponseData.length);

        if (paramObject.id > 0) {
          // console.log("Always update case");
          // For Binding the data for Updated time
          axios
            .get(
              `${config.itemsBaseUrl}/items/locationfindbyid?id=${paramObject.id}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              // console.log("locationdataresponse::>>", res.data.ResponseData);
              if (res.data.ResponseData.Items.length > 0) {
                // console.log("-------- IF ---------");
                // console.log("If Location Length ==> ", locationlength);

                let overridedefault = [];
                let overtaxdefault = [];

                // For setting the state of the overrideDefaults and overTaxDefault
                for (let i = 0; i < res.data.ResponseData.Items.length; i++) {
                  overridedefault.push(
                    res.data.ResponseData.Items[i].OverridePrices === 1
                      ? true
                      : false
                  );
                  overtaxdefault.push(
                    res.data.ResponseData.Items[i].OverrideTax === 1
                      ? true
                      : false
                  );
                }

                // console.log("overridedefault ==>", overridedefault);
                setOverRidePricesValues(overridedefault);

                // console.log("overtaxdefault ==>", overtaxdefault);
                setOverDefaultTaxValues(overtaxdefault);

                // Location Data handling
                // console.log(res.data.ResponseData.Items);
                let items = [];
                for (let i = 0; i < res.data.ResponseData.Items.length; i++) {
                  let taxItemData =
                    res.data.ResponseData.Itemslocationtaxes?.filter(function (
                      locationItem
                    ) {
                      return (
                        locationItem.LocationId ===
                        res.data.ResponseData.Items[i].LocationId
                      );
                    });

                  items.push({
                    LocationItemId: res.data.ResponseData.Items[i].Id,
                    LocationId: res.data.ResponseData.Items[i].LocationId,
                    DoNotSell: res.data.ResponseData?.Items[i].DoNotSell,
                    Location: res.data.ResponseData.Items[i].Location,
                    ReorderLevel: parseFloat(
                      res.data.ResponseData.Items[i].ReorderLevel
                    ),
                    ReplenishLevel: parseFloat(
                      res.data.ResponseData.Items[i].ReplenishLevel
                    ),
                    HideGrid: res.data.ResponseData.Items[i].HideGrid,
                    OverridePrices:
                      res.data.ResponseData.Items[i].OverridePrices,
                    CostPrice: parseFloat(
                      res.data.ResponseData.Items[i].CostPrice
                    ),
                    UnitPrice: parseFloat(
                      res.data.ResponseData.Items[i].UnitPrice
                    ),
                    PromoPrice: parseFloat(
                      res.data.ResponseData.Items[i].PromoPrice
                    ),
                    PromoStartDate: Moment(
                      res.data.ResponseData.Items[i].PromoStartDate
                    ).format("yyyy-MM-DD"),
                    PromoEndDate: Moment(
                      res.data.ResponseData.Items[i].PromoEndDate
                    ).format("yyyy-MM-DD"),
                    OverrideTax: res.data.ResponseData.Items[i].OverrideTax,
                    // TaxCumulative: res.data.ResponseData.Itemslocationtaxes[i].Cumulative,
                    TaxGroup: res.data.ResponseData.Items[i].TaxGroup,
                    // Tax1: taxItemData[0].Name,
                    // Tax2: taxItemData[1].Name,
                    // Tax3: taxItemData[2].Name,
                    // Tax4: taxItemData[3].Name,
                    // Tax5: taxItemData[4].Name,
                    // TaxPercentage1: parseFloat(taxItemData[0].Percent),
                    // TaxPercentage2: parseFloat(taxItemData[1].Percent),
                    // TaxPercentage3: parseFloat(taxItemData[2].Percent),
                    // TaxPercentage4: parseFloat(taxItemData[3].Percent),
                    // TaxPercentage5: parseFloat(taxItemData[4].Percent),
                    // Tax1Id: taxItemData[0].Id,
                    // Tax2Id: taxItemData[1].Id,
                    // Tax3Id: taxItemData[2].Id,
                    // Tax4Id: taxItemData[3].Id,
                    // Tax5Id: taxItemData[4].Id,
                  });
                }
                setLocationItem(items);

                // Location Tax Handling
                let taxitems = [];
                for (
                  let i = 0;
                  i < res.data.ResponseData.Itemslocationtaxes.length;
                  i++
                ) {
                  taxitems.push({
                    LocationId:
                      res.data.ResponseData.Itemslocationtaxes[i].LocationId,
                    TaxId: res.data.ResponseData.Itemslocationtaxes[i].Id,
                    TaxName: res.data.ResponseData.Itemslocationtaxes[i].Name,
                    TaxPercent:
                      res.data.ResponseData.Itemslocationtaxes[i].Percent,
                    TaxCumulative:
                      res.data.ResponseData.Itemslocationtaxes[i].Cumulative,
                  });
                }

                // Setting the value for the update of variation
                // console.log(
                //   "Call variation : ",
                //   res.data.ResponseData.Itemslocationvariations
                // );
                setVariationItem(res.data.ResponseData.Itemslocationvariations);

                let variationcostprice = [];
                let variationunitprice = [];
                let variationreorderlevel = [];
                let variationreplenishlevel = [];
                // console.log(
                //   "res.data.ResponseData.Itemslocationvariations ==>",
                //   res.data.ResponseData.Itemslocationvariations
                // );
                const VariationItem =
                  res.data.ResponseData.Itemslocationvariations;

                for (let i = 0; i < VariationItem.length; i++) {
                  // console.log("i: ", i);
                  variationcostprice.push({
                    LocationId: VariationItem[i].LocationId,
                    ItemVariationId: VariationItem[i].VariationId,
                    CostPrice: VariationItem[i].CostPrice,
                    LocationItemVariationID: VariationItem[i].Id,
                  });
                  variationunitprice.push({
                    LocationId: VariationItem[i].LocationId,
                    ItemVariationId: VariationItem[i].VariationId,
                    UnitPrice: VariationItem[i].UnitPrice,
                    LocationItemVariationID: VariationItem[i].Id,
                  });
                  variationreorderlevel.push({
                    LocationId: VariationItem[i].LocationId,
                    ItemVariationId: VariationItem[i].VariationId,
                    ReorderLevel: VariationItem[i].ReorderLevel,
                    LocationItemVariationID: VariationItem[i].Id,
                  });
                  variationreplenishlevel.push({
                    LocationId: VariationItem[i].LocationId,
                    ItemVariationId: VariationItem[i].VariationId,
                    ReplenishLevel: VariationItem[i].ReorderLevel,
                    LocationItemVariationID: VariationItem[i].Id,
                  });
                }

                // console.log("variationcostprice: ", variationcostprice);
                // console.log("variationcostprice: ", variationcostprice);

                setInputCostPriceValues(variationcostprice);
                setInputUnitPriceValues(variationunitprice);
                setInputReorderLevelValues(variationreorderlevel);
                setInputReplenishLevelValues(variationreplenishlevel);

                // console.log("--------------------------------");
                // console.log("inputCostPriceValues => ", inputCostPriceValues);

                // // console.log("--------------------------------");
                // console.log("inputUnitPriceValues => ", inputUnitPriceValues);

                setLoading(false);
              } else {
                // console.log("-------- ELSE --------");
                // console.log("ELSE Location Length: ", locationlength);
                axios
                  .get(
                    `${config.priceRulesBaseUrl}/pricerules/locationdropdown`,
                    {
                      headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        Authorization: token,
                      },
                    }
                  )
                  .then((res) => {
                    // console.log("locationlength", res.data.ResponseData);
                    let items = [];
                    for (let i = 0; i < locationlength; i++) {
                      items.push({
                        LocationItemId: 0,
                        LocationId: res.data.ResponseData[i].Id,
                        DoNotSell: 0,
                        Location: "",
                        ReorderLevel: "",
                        ReplenishLevel: "",
                        HideGrid: 0,
                        OverridePrices: 0,
                        CostPrice: "",
                        UnitPrice: "",
                        PromoPrice: "",
                        PromoStartDate: "",
                        PromoEndDate: "",
                        OverrideTax: 0,
                        TaxCumulative: 0,
                        Tax1: "",
                        Tax2: "",
                        Tax3: "",
                        Tax4: "",
                        Tax5: "",
                        TaxPercentage1: "",
                        TaxPercentage2: "",
                        TaxPercentage3: "",
                        TaxPercentage4: "",
                        TaxPercentage5: "",
                      });
                    }
                    setLocationItem(items);

                    // console.log("locationItem: ", 1, locationItem);

                    axios
                      .get(
                        `${config.itemsBaseUrl}/items/itemsvariationslist?id=${paramObject.id}`,
                        {
                          headers: {
                            "Content-Type": "application/json;charset=UTF-8",
                            Authorization: token,
                          },
                        }
                      )
                      .then((res) => {
                        // console.log(
                        //   "item variation response ==> ",
                        //   res.data.ResponseData
                        // );
                        setVariationItem(res.data.ResponseData.customefield);
                        setVariationLength(res.data.ResponseData.length);

                        let variationlength =
                          res.data.ResponseData.customefield.length;
                        // console.log(
                        //   "inner axios length locationlength: ",
                        //   locationlength,
                        //   variationlength
                        // );

                        let arrayLength = locationlength * variationlength;

                        setInputCostPriceValues(Array(arrayLength).fill(null));
                        setInputUnitPriceValues(Array(arrayLength).fill(null));
                        setInputReorderLevelValues(
                          Array(arrayLength).fill(null)
                        );
                        setInputReplenishLevelValues(
                          Array(arrayLength).fill(null)
                        );
                      });
                  })
                  .catch((err) => {
                    console.log("err: ", err);
                  });
              }
            })
            .catch((err) => {
              console.log("err: ", err);
            });
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  }, [props]);

  // Handle all the UPSERT events
  const handleSubmit = () => {
    let filterCostPrice = inputCostPriceValues?.filter(function (
      costPriceItem
    ) {
      return costPriceItem !== undefined;
    });
    let filterUnitPrice = inputUnitPriceValues?.filter(function (
      unitPriceItem
    ) {
      return unitPriceItem !== undefined;
    });
    let filterReorderLevel = inputReorderLevelValues?.filter(function (
      reorderLevelPriceItem
    ) {
      return reorderLevelPriceItem !== undefined;
    });
    let filterReplenishLevel = inputReplenishLevelValues?.filter(function (
      replenishLevelItem
    ) {
      return replenishLevelItem !== undefined;
    });

    // For Location Variation
    // Merging all the object into one array of CostPrice, UnitPrice, ReorderLevel and ReplenishLevel
    // console.log("filterCostPrice: ", filterCostPrice);
    // console.log("filterUnitPrice: ", filterUnitPrice);
    // console.log("filterReorderLevel: ", filterReorderLevel);
    // console.log("filterReplenishLevel: ", filterReplenishLevel);

    let mergedVariation = filterCostPrice
      .concat(filterUnitPrice, filterReorderLevel, filterReplenishLevel)
      .reduce((acc, curr) => {
        let match = acc.find(
          (item) =>
            item?.LocationId == curr?.LocationId &&
            item?.ItemVariationId === curr?.ItemVariationId
        );
        if (match) {
          Object.assign(match, curr);
        } else {
          acc.push(curr);
        }
        return acc;
      }, []);

    // console.log("mergedVariation: ", mergedVariation);

    // For Location Taxes
    // To change all the taxes format
    const numLocations = locationItem.length;
    const numTaxesPerLocation = Math.ceil(locationItem.length / numLocations);
    const taxArray = [];

    for (let locationIndex = 0; locationIndex < numLocations; locationIndex++) {
      const startTaxIndex = locationIndex * numTaxesPerLocation;
      const endTaxIndex = startTaxIndex + numTaxesPerLocation;
      const taxes = [];

      for (let i = startTaxIndex; i < endTaxIndex; i++) {
        const item = locationItem[i];
        for (let j = 1; j <= 5; j++) {
          if (item[`Tax${j}`]) {
            taxes.push({
              LocationId: locationIndex + 1,
              TaxId: paramObject.id > 0 ? item[`Tax${j}Id`] : 0,
              TaxName: item[`Tax${j}`],
              TaxPercent: item[`TaxPercentage${j}`],
              TaxCumulative: item[`TaxCumulative`],
            });
          }
        }
      }

      taxArray.push(taxes);
    }

    const mergedTaxArr = [].concat(...taxArray);
    // console.log("mergedTaxArr", mergedTaxArr);

    // To filter all null values of Location data
    let LocationItemData = locationItem?.filter(function (locationItem) {
      return locationItem?.Location !== "";
    });

    // To filter all null values of Taxes  data
    let TaxItemData = mergedTaxArr?.filter(function (taxItem) {
      return taxItem?.TaxName !== "";
    });

    // To filter all null values of Variation data
    let VariationItemData = mergedVariation?.filter(function (variationItem) {
      return variationItem?.CostPrice !== "";
    });

    // XML object declare
    const locationItemobj = {};
    const taxItemobj = {};
    const variationobj = {};

    // After filtering the array to set to particular object
    locationItemobj.LocationItemDataXML = LocationItemData;
    taxItemobj.LocationItemTaxDataXML = TaxItemData;
    variationobj.LocationItemVariationDataXML = VariationItemData;

    // Object are converted to JSON string
    let locationitemjsonstring = JSON.stringify(locationItemobj);
    let taxitemjsonstring = JSON.stringify(taxItemobj);
    let variationitemjsonstring = JSON.stringify(variationobj);

    // To check whether all the string all the jsonstring are better
    // console.log("locationitemjsonstring: ", locationitemjsonstring);
    // console.log("taxitemjsonstring: ", taxitemjsonstring);
    // console.log("variationitemjsonstring: ", variationitemjsonstring);
    setLoading(true);

    // Location Upsert API Call
    axios
      .post(
        `${config.itemsBaseUrl}/items/locationupsert`,
        {
          locationitemxml: locationitemjsonstring,
          taxxml: taxitemjsonstring,
          variationxml: variationitemjsonstring,
          itemid: paramObject.id || 0,
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error: ", error);
      });
  };

  const handleDataChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: newValue,
    }));
  };
  console.log("FormValuess:>>>", formValues);
  return (
    <>
      <Loader loading={loading} />
      {/* {totalLocation?.map((data, locationIndex) => {
        return (
          <>
            <div className="for-box mb-5" key={locationIndex}>
              <div className="card">
                <div className="card-header">
                  <div className="mt-1 fw-bolder fs-6 ">
                    <GrLocation className="me-1" />
                    {data.Name} (Fields in red are required)
                  </div>
                </div>

                <div className="card-body">
                  <Formik
                    {...props}
                    initialValues={locationItem}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    <Form
                      onKeyPress={(e) =>
                        e.key === "Enter" && e.preventDefault()
                      }
                    >
                      <div className="row">
                        <div className="col-md-3 mb-3" key={locationIndex}>
                          <input
                            type="hidden"
                            name="LocationId"
                            value={data.Id}
                          />
                          <Field
                            type="checkbox"
                            className="checkbox form-check-input me-3 mx-4"
                            id={`DoNotSell`}
                            name={`DoNotSell`}
                            checked={
                              paramObject.id > 0
                                ? locationItem[locationIndex]?.DoNotSell === 1
                                : doNotSellValues[
                                `checkbox${locationIndex + 1}`
                                ]
                            }
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />

                          <label className="form-check-label me-3">
                            Do Not Sell At This Location
                          </label>
                        </div>
                        <div className="col-md-2 ms-3" key={locationIndex}>
                          <Field
                            type="checkbox"
                            className="checkbox form-check-input me-3"
                            id={`HideGrid`}
                            name={`HideGrid`}
                            checked={
                              paramObject.id > 0
                                ? locationItem[locationIndex]?.HideGrid === 1
                                : hideGridValues[`checkbox${locationIndex + 1}`]
                            }
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />
                          <label className="form-check-label me-3">
                            Hide From Grid
                          </label>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-2 mb-3 align-center">
                          <label className="form-label">
                            Location At Store:
                          </label>
                        </div>
                        <div className="col-md-3 mb-3" key={locationIndex}>
                          <Field
                            type="text"
                            className="form-control"
                            id="Location"
                            name="Location"
                            value={locationItem[locationIndex]?.Location}
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />
                        </div>
                        <div className="col-md-1 mb-3 align-center">
                          <label className="form-label">Reorder Level:</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <Field
                            type="number"
                            className="form-control"
                            id={`ReorderLevel`}
                            name={`ReorderLevel`}
                            value={locationItem[locationIndex]?.ReorderLevel}
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />
                        </div>
                        <div className="col-md-2 mb-3 align-center">
                          <label className="form-label">Replenish Level:</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <Field
                            type="number"
                            className="form-control"
                            id={`ReplenishLevel`}
                            name={`ReplenishLevel`}
                            value={locationItem[locationIndex]?.ReplenishLevel}
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-12 mb-3">
                        <Field
                          type="checkbox"
                          className="checkbox form-check-input me-3 mx-4"
                          id={`OverridePrices`}
                          name={`OverridePrices`}
                          checked={
                            locationItem[locationIndex]?.OverridePrices === 1
                          }
                          onChange={(event) => {
                            handleOverridePricesChange(locationIndex, event);
                            handleChangeForValues(locationIndex, event);
                          }}
                        />
                        <label className="form-check-label me-3">
                          Override Prices
                        </label>
                      </div>
                      {overRidePricesValues[locationIndex] && (
                        <>
                          <div>
                            <div className="row">
                              <div className="col-md-2 mb-3 align-center">
                                <label className="form-label">
                                  Cost Price (Without Tax):
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`CostPrice`}
                                  name={`CostPrice`}
                                  value={locationItem[locationIndex]?.CostPrice}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3 align-center">
                                <label className="form-label">
                                  Selling Price:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`UnitPrice`}
                                  name={`UnitPrice`}
                                  value={locationItem[locationIndex]?.UnitPrice}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3 align-center">
                                <label className="form-label">
                                  Promo Price:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3 ">
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`PromoPrice`}
                                  name={`PromoPrice`}
                                  value={
                                    locationItem[locationIndex]?.PromoPrice
                                  }
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3 align-center mt-2">
                                Promo Start Date:
                              </div>
                              <div className="col-md-2 mb-3 mt-3">
                                <div className="input-group date">
                                  <span className="input-group-append">
                                    <span className="input-group-text bg-light d-block">
                                      <i className="fa fa-calendar"></i>
                                    </span>
                                  </span>
                                  <Field
                                    type="date"
                                    className="form-control"
                                    id={`PromoStartDate`}
                                    name={`PromoStartDate`}
                                    value={
                                      locationItem[locationIndex]
                                        ?.PromoStartDate
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2 mb-3 align-center mt-2">
                                Promo End Date:
                              </div>
                              <div className="col-md-2 mb-3 mt-3">
                                <div
                                  className="input-group date"
                                  id="datepicker"
                                >
                                  <span className="input-group-append">
                                    <span className="input-group-text bg-light d-block">
                                      <i className="fa fa-calendar"></i>
                                    </span>
                                  </span>
                                  <Field
                                    type="date"
                                    className="form-control"
                                    id={`PromoEndDate`}
                                    name={`PromoEndDate`}
                                    value={
                                      locationItem[locationIndex]?.PromoEndDate
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-md-12 mb-3">
                        <Field
                          type="checkbox"
                          className="checkbox form-check-input me-3 mx-4"
                          id={`OverrideTax`}
                          name={`OverrideTax`}
                          // checked={overDefaultTaxValues[locationIndex]}
                          checked={
                            locationItem[locationIndex]?.OverrideTax === 1
                          }
                          onChange={(event) => {
                            handleOverrideDefaultTaxChange(
                              locationIndex,
                              event
                            );
                            handleChangeForValues(locationIndex, event);
                          }}
                        />
                        <label className="form-check-label me-3">
                          Override Default Tax
                        </label>
                      </div>
                      {overDefaultTaxValues[locationIndex] && (
                        <>
                          <div className="row">
                            <div className="col-md-2">
                              <label className="align-center">Tax Group:</label>
                            </div>
                            <div className="col-md-10 mb-3">
                              <Select
                                onChange={(event) =>
                                  handleChangeForValues(
                                    locationIndex,
                                    event,
                                    "TaxGroup"
                                  )
                                }
                                value={taxGroupOptions.find(
                                  (obj) =>
                                    obj.value ==
                                    locationItem[locationIndex]?.TaxGroup
                                )}
                                options={taxGroupOptions}
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                isClearable={true}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                id="TaxGroup"
                                name="TaxGroup"
                              />
                            </div>
                            <h4 className="col-md-12 align-center">OR</h4>
                            <div className="row mt-2">
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 1:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax1`}
                                  name={`Tax1`}
                                  value={locationItem[locationIndex]?.Tax1}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage1`}
                                    name={`TaxPercenatge1`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage1
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 2:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax2`}
                                  name={`Tax2`}
                                  value={locationItem[locationIndex]?.Tax2}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage2`}
                                    name={`TaxPercentage2`}
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage2
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 3:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax3`}
                                  name={`Tax3`}
                                  value={locationItem[locationIndex]?.Tax3}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage3`}
                                    name={`TaxPercentage3`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage3
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 4:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax4`}
                                  name={`Tax4`}
                                  value={locationItem[locationIndex]?.Tax4}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage4`}
                                    name={`TaxPercentage4`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage4
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 5:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax5`}
                                  name={`Tax5`}
                                  value={locationItem[locationIndex]?.Tax5}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage5`}
                                    name={`TaxPercentage5`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage5
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                              <div className="col-md-2 ms-4 mb-3">
                                <Field
                                  type="checkbox"
                                  className="checkbox form-check-input ms-5 me-4"
                                  id={`TaxCumulative`}
                                  name={`TaxCumulative`}
                                  checked={
                                    locationItem[locationIndex]
                                      ?.TaxCumulative === 1
                                  }
                                  // checked={
                                  //   taxCumulativeValues[
                                  //     `checkbox${locationIndex + 1}`
                                  //   ]
                                  // }
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />

                                <label className="form-check-label">
                                  Tax Cumulative
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {variationItem.length > 0 && (
                        <>
                          <label className="form-check-label mt-2 ms-4 mb-3">
                            Item Variations:
                          </label>
                          <div className="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Supplier</th>
                                  <th>Name/Item Attributes</th>
                                  <th>Cost Price</th>
                                  <th>Selling Price</th>
                                  <th>Reorder Level</th>
                                  <th>Replenish Level</th>
                                </tr>
                              </thead>

                              <tbody>
                                {variationItem
                                  // .filter(
                                  //   (u) => u.LocationId === locationIndex + 1
                                  // )
                                  .map((u, variationIndex) => {
                                    const inputIndex =
                                      locationIndex * variationItem.length +
                                      variationIndex;
                                    return (
                                      <tr key={variationIndex}>
                                        <td>{u.SupplierName}</td>
                                        <td>{u.VariationName}</td>
                                        <td>
                                          <Field
                                            type="number"
                                            className="form-control"
                                            id={`CostPrice-${variationIndex}`}
                                            name={`CostPrice`}
                                            defaultValue={parseFloat(
                                              u.CostPrice
                                            )}
                                            // value={parseFloat(u.CostPrice)}
                                            onChange={(event) =>
                                              handleInputCostPriceChange(
                                                event,
                                                inputIndex,
                                                u.VariationId,
                                                data.Id,
                                                paramObject.id > 0 ? u.Id : 0
                                              )
                                            }
                                          // onChange={(event) =>
                                          //   handleInputCostPriceChange(
                                          //     event,
                                          //     variationIndex,
                                          //     data.Id
                                          //   )
                                          // }
                                          />
                                        </td>
                                        <td>
                                          <Field
                                            type="number"
                                            className="form-control"
                                            id={`UnitPrice-${variationIndex}`}
                                            name={`UnitPrice`}
                                            defaultValue={parseFloat(
                                              u.UnitPrice
                                            )}
                                            onChange={(event) =>
                                              handleInputUnitPriceChange(
                                                event,
                                                inputIndex,
                                                u.VariationId,
                                                data.Id,
                                                paramObject.id > 0 ? u.Id : 0
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Field
                                            type="number"
                                            className="form-control"
                                            id={`ReorderLevel-${variationIndex}`}
                                            name={`ReorderLevel`}
                                            defaultValue={parseFloat(
                                              u.ReorderLevel
                                            )}
                                            onChange={(event) =>
                                              handleInputReorderLevelChange(
                                                event,
                                                inputIndex,
                                                u.VariationId,
                                                data.Id,
                                                paramObject.id > 0 ? u.Id : 0
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Field
                                            type="number"
                                            className="form-control"
                                            id={`ReplenishLevel-${variationIndex}`}
                                            name={`ReplenishLevel`}
                                            defaultValue={parseFloat(
                                              u.ReplenishLevel
                                            )}
                                            onChange={(event) =>
                                              handleInputReplenishLevelChange(
                                                event,
                                                inputIndex,
                                                u.VariationId,
                                                data.Id,
                                                paramObject.id > 0 ? u.Id : 0
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </>
        );
      })} */}
      {item && (
        <div className="card card-body">
          <div className="card-header d-flex justify-content-between align-items-center p-1">
            <h5 className="card-title">Items Rack</h5>
            <div>
              {props.currentStep > 1 && (
                <button
                  onClick={handleBack}
                  className="btn btn-sm btn-secondary btn-md me-1"
                >
                  Back
                </button>
              )}
              {props.currentStep < props.totalSteps && (
                <button
                  className="btn btn-sm btn-primary btn-md"
                  type="button"
                  onClick={handleButtonClick}
                >
                  Next
                </button>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="row">
            {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 1710-1735
              <div className="col-md-3 mt-2">
                <input
                  type="checkbox"
                  className="checkbox form-check-input me-3"
                  name="DoNotSellAtThisLocation"
                  checked={formValues?.DoNotSellAtThisLocation == 1}
                  onClick={(e) => handleDataChange(e)}
                ></input>
                <label className="form-check-label p-lg-medium">
                  Do Not Sell At This Location
                </label>
              </div>

              <div className="col-md-3 mt-3">
                <input
                  type="checkbox"
                  className="checkbox form-check-input me-3"
                  name="HideFromGrid"
                  checked={formValues?.HideFromGrid == 1}
                  onClick={(e) => handleDataChange(e)}
                ></input>
                <label className="form-check-label p-lg-medium">
                  Hide From Grid
                </label>
              </div> */}

              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-check-label p-lg-medium">
                      Location At Store:
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      name="Location"
                      value={formValues?.Location}
                      onChange={(e) => handleDataChange(e)}
                    ></input>
                  </div>
                </div>
              </div>
            </div>

            {item.length > 0 ? (
              <div className="row mt-3">
                <h5 className="form-label col-md-5 mb-3 fw-bold p-medium">
                  {isItem ? "Locations Of  Item" : "Locations Of Variations"}
                </h5>
                <div className="col-md-12 mb-3">
                  <table
                    id="AdditionalItem"
                    name="AdditionalItem"
                    className="table table-responsive"
                  >
                    <thead>
                      <tr>
                        <th className="p-regular">Name</th>
                        <th className="p-regular">Aisle</th>
                        <th className="p-regular">Rack</th>
                        <th className="p-regular">Shelf</th>
                        <th className="p-regular">Bin</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item?.map((data, index) => {
                        const {
                          variationid,
                          VariationName,
                          bin,
                          aisle,
                          rack,
                          shelf,
                        } = data;
                        let AisleArray = [];
                        let AisleData = [];
                        let RackArray = [];
                        let ShelfArray = [];
                        let BinArray = [];
                        if (aisle != "") {
                          const AisleValue = aisle
                            ?.trim()
                            .split(",")
                            ?.map((str) => parseInt(str.trim()));
                          AisleArray = AisleValue;
                          AisleData = Aislelist?.filter((obj) =>
                            AisleArray?.includes(obj.value)
                          );
                          // console.log("AisleArray", AisleArray);
                        }
                        if (rack != "") {
                          const RackValue = rack
                            ?.trim()
                            .split(",")
                            ?.map((str) => Number(str.trim()));
                          RackArray = RackValue;
                        }
                        if (shelf != "") {
                          const ShelfValue = shelf
                            ?.trim()
                            .split(",")
                            ?.map((str) => Number(str.trim()));
                          ShelfArray = ShelfValue;
                        }
                        if (bin != "") {
                          const BinValue = bin
                            ?.trim()
                            .split(",")
                            ?.map((str) => Number(str.trim()));
                          BinArray = BinValue;
                        }
                        return (
                          <tr key={index}>
                            <td style={{ padding: "0.3rem" }}>
                              <input
                                type="hidden"
                                name="variationid"
                                // value={variationid}
                              />
                              {VariationName}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isMulti={true}
                                isClearable={true}
                                onChange={(event) => handleAisle(index, event)}
                                options={Aislelist}
                                placeholder="Aisle"
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                // value={Aislelist.filter((obj) =>
                                //   AisleArray?.includes(obj.value)
                                // )}
                                value={AisleData}
                                id="Aisle"
                                name="Aisle"
                                className="custom-search-select"
                              />
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isMulti={true}
                                isClearable={true}
                                onChange={(event) => handleRack(index, event)}
                                options={Racklist}
                                placeholder="Rack"
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={Racklist?.filter((obj) =>
                                  RackArray?.includes(obj.value)
                                )}
                                id="Rack"
                                name="Rack"
                                className="custom-search-select"
                              />
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isMulti={true}
                                isClearable={true}
                                onChange={(event) => handleShelf(index, event)}
                                options={Shelflist}
                                placeholder="Shelf"
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={Shelflist?.filter((obj) =>
                                  ShelfArray?.includes(obj.value)
                                )}
                                id="Shelf"
                                name="Shelf"
                                className="custom-search-select"
                              />
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isMulti={true}
                                isClearable={true}
                                onChange={(event) => handleBin(index, event)}
                                options={Binlist}
                                placeholder="Bins"
                                // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={Binlist?.filter((obj) =>
                                  BinArray?.includes(obj.value)
                                )}
                                id="Bins"
                                name="Bins"
                                className="custom-search-select"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <div className="text-center mb-2 mt-4">
              {props.currentStep > 1 && (
                <button
                  type="button"
                  onClick={handleBack}
                  className="btn btn-sm btn-secondary me-3"
                >
                  Back
                </button>
              )}
              {props.currentStep < props.totalSteps && (
                <button
                  type="submit"
                  className="btn btn-sm btn-secondary me-3"
                  ref={buttonRef}
                  onClick={handleItemsRackSubmit}
                >
                  Next
                </button>
              )}
              <button
                onClick={handleSubmitForm}
                className="btn btn-sm btn-primary btn-md me-3"
                id="btn_submit"
                type="submit"
              >
                Save
              </button>
              <Link to="/items" className="btn btn-sm btn-secondary btn-md">
                Cancel
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* {totalLocation?.length > 0 && <ActionButtons {...props} />} */}
    </>
  );
};

export default Locations;
